import apiClient from '@/api/client';

export default {

    login(data) {
        return apiClient.post('users/login', data);
    },

    logout(data) {
        return apiClient.post('users/logout', data);
    },

}
